module.exports = __webpack_public_path__ + "static/media/tree-view-selection-method.2c39b89e.jpg";